import React, { useState, useEffect, useRef} from "react"
import { Bar, Doughnut, Pie } from 'react-chartjs-2'
import { Legend } from "./styles";
import BeatLoader from "react-spinners/BeatLoader";

const GetSimpleBarGraph = ({title,chartTypes,productionDataSet,
   allProductionCharts,allDispatchCharts, allgetInwardCharts, allgetInventoryCharts,
   productionBarChartData,productionBarChartOptions,
   inventoryBarChartdata,inventoryBarChartoptions, PieChartoptions,
   dispatchBarChartdata,dispatchBarChartoptions,LineChartOPtions,LineData,
   inwardBarChartdata,inwardBarChartoptions,isLoader,count}) => {
    const [isActive, setIsActive] = useState(false)


    let scrollabledDiv = {
    overflowY: 'auto',
    marginTop: '-3px',
    marginRight:'41px',
    width: '453px',
    height: '50px',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    marginInlineStart: '7px',
    overflowX: 'hidden'
    }

    const NoDataComponent = () =>{
      return (
        <div style={{width: '100%',height: '100%',position: 'relative'}}>
        <div style={{textAlign: 'center',width: '100%',height: '100%',position: 'absolute',left: '0',top: '62px',fontSize:"22px"}}>
            <span>No data</span>
        </div>
        </div>
      )
    }


    const BarChart = props => {
      const productionChartRef = useRef(null);
      useEffect(() => {
        document.getElementById("productionlegend").innerHTML = productionChartRef.current.chartInstance.generateLegend();
      }, []);
      return (
          <div>
            <Bar width={500}
            height={300} 
            data={props.data} 
            options={props.options}
            ref={productionChartRef} />
              <Legend id='productionlegend' style={scrollabledDiv}/>
          </div>
      );
    }

    const DispatchBarChart = props => {
      const dispatchChartRef = useRef(null);
      useEffect(() => {
            document.getElementById("dispatchlegend").innerHTML = dispatchChartRef.current.chartInstance.generateLegend();
          },[]);
      return (
          <div>
            <Bar width={500}
            height={300} 
            data={props.data} 
            options={props.options} 
            ref={dispatchChartRef} />
          <Legend id="dispatchlegend" style={scrollabledDiv} />
          </div>
      );
    };

    const InwardBarChart = props => {
      const inwardChartRef = useRef(null);
        useEffect(() => {
        document.getElementById("inwardlegend").innerHTML = inwardChartRef.current.chartInstance.generateLegend();
      }, []);
      return (
          <div>
            <Bar width={500}
            height={300} 
            data={props.data} 
            options={props.options} 
            ref={inwardChartRef} />
            <Legend id="inwardlegend" style={scrollabledDiv} />
          </div>
      );
    };
    

    const InventoryBarChart = props => {
      const invChartRef = useRef(null);
      useEffect(() => {
        document.getElementById("inventorylegend").innerHTML = invChartRef.current.chartInstance.generateLegend();
      }, []);
      return (
          <div>
            <Bar width={500}
            height={300} 
            data={props.data} 
            options={props.options} 
            ref={invChartRef} />
            <Legend id="inventorylegend" style={scrollabledDiv} />
          </div>
      );
    };

    const productionCharts = (charts,productionCount) => {
        switch (charts) {
          case 'ProductionBar':
            return (
              <>
              {isLoader ? 
               <div style={{ textAlign: 'center', marginTop: '13%', position:'absolute', marginLeft:'40%' }}>
               <BeatLoader />
           </div> : 
           productionCount > 0 ? 
              <BarChart
             data={productionBarChartData}
             options={productionBarChartOptions}>
           </BarChart> : 
           <NoDataComponent />}
           </>
            )
          case 'ProductionPie':
            return (
              <>
              {isLoader ? 
               <div style={{ textAlign: 'center', marginTop: '13%', position:'absolute', marginLeft:'40%' }}>
               <BeatLoader />
           </div> : productionCount > 0 ? 
              <Pie
                height='200%'
                data={productionBarChartData}
                options={PieChartoptions}
                >
              </Pie> : <NoDataComponent />}
              </>
            )
          case 'ProductionDoughnut':
            return (
              <>
              {isLoader ? 
               <div style={{ textAlign: 'center', marginTop: '13%', position:'absolute', marginLeft:'40%' }}>
               <BeatLoader />
           </div> : productionCount > 0 ?
              <Doughnut
                height='200%'
                data={productionBarChartData}
                options={PieChartoptions}>
              </Doughnut> : <NoDataComponent />}
              </>
            )
          default:
            return (
              <>
              {isLoader ? 
               <div style={{ textAlign: 'center', marginTop: '13%', position:'absolute', marginLeft:'40%' }}>
               <BeatLoader />
           </div> : productionCount > 0 ?
             <BarChart
             data={productionBarChartData}
             options={productionBarChartOptions}>
           </BarChart> : <NoDataComponent />}
            </>
            )
        }
      }
    
      const dispatchCharts = (charts, dispatchCount) => {
        switch (charts) {
          case 'DispatchBar':
            return (
              <>
              {isLoader ? 
                <div style={{ textAlign: 'center', marginTop: '13%', position:'absolute', marginLeft:'40%' }}>
                <BeatLoader />
            </div> : 
            dispatchCount > 0 ? 
              <DispatchBarChart
              data={dispatchBarChartdata}
              options={dispatchBarChartoptions}
              >
            </DispatchBarChart> : <NoDataComponent/>}</>
            )
          case 'DispatchPie':
            return (
              <>
              {isLoader ? 
                <div style={{ textAlign: 'center', marginTop: '13%', position:'absolute', marginLeft:'40%' }}>
                <BeatLoader />
            </div> : dispatchCount > 0 ? 
              <Pie
                height='200%'
                data={dispatchBarChartdata}
                options={PieChartoptions}>
              </Pie> : <NoDataComponent/>}</>
            )
          case 'DispatchDoughnut':
            return (
              <>
              {isLoader ? 
                <div style={{ textAlign: 'center', marginTop: '13%', position:'absolute', marginLeft:'40%' }}>
                <BeatLoader />
            </div> : dispatchCount > 0 ?
              <Doughnut
                height='200%'
                data={dispatchBarChartdata}
                options={PieChartoptions}>
              </Doughnut> : <NoDataComponent/>}</>
            )
          default:
            return (
              <>
              {isLoader ? 
               <div style={{ textAlign: 'center', marginTop: '13%', position:'absolute', marginLeft:'40%' }}>
               <BeatLoader />
           </div> : dispatchCount > 0 ?
               <DispatchBarChart
               data={dispatchBarChartdata}
               options={dispatchBarChartoptions}
               >
             </DispatchBarChart> : <NoDataComponent />}
              </>
            )
        }
      }
    
      const inwardCharts = (charts, inwardCount) => {
        switch (charts) {
          case 'InwardBar':
            return (
              <>
              {isLoader ? 
                <div style={{ textAlign: 'center', marginTop: '13%', position:'absolute', marginLeft:'40%' }}>
                <BeatLoader />
            </div> : inwardCount > 0 ? 
              <InwardBarChart
                data={inwardBarChartdata}
                options={inwardBarChartoptions}
                >
              </InwardBarChart> : <NoDataComponent/>}</>
            )
          case 'InwardPie':
            return (
              <>
              {isLoader ? 
                <div style={{ textAlign: 'center', marginTop: '13%', position:'absolute', marginLeft:'40%' }}>
                <BeatLoader />
            </div> : inwardCount > 0 ? 
              <Pie
                height='200%'
                data={inwardBarChartdata}
                options={PieChartoptions}>
              </Pie> : <NoDataComponent/>}</>
            )
          case 'InwardDoughnut':
            return (
              <>
              {isLoader ? 
                <div style={{ textAlign: 'center', marginTop: '13%', position:'absolute', marginLeft:'40%' }}>
                <BeatLoader />
            </div> : inwardCount > 0 ?
              <Doughnut
                height='200%'
                data={inwardBarChartdata}
                options={PieChartoptions}>
              </Doughnut> : <NoDataComponent />}</>
            )
          default:
            return (
              <>
              {isLoader ? 
                <div style={{ textAlign: 'center', marginTop: '13%', position:'absolute', marginLeft:'40%' }}>
                <BeatLoader />
            </div> : inwardCount > 0 ? 
               <InwardBarChart
               data={inwardBarChartdata}
               options={inwardBarChartoptions}
               >
             </InwardBarChart> : <NoDataComponent/>}
              </>
            )
        }
      }
      
      const inventoryCharts = (charts, inventoryCount) => {
        switch (charts) {
          case 'InventoryBar':
            return (
              <>
              {isLoader ? 
                <div style={{ textAlign: 'center', marginTop: '13%', position:'absolute', marginLeft:'40%' }}>
                <BeatLoader />
            </div> : inventoryCount > 0 ? 
              <InventoryBarChart
                data={inventoryBarChartdata}
                options={inventoryBarChartoptions}
                >
              </InventoryBarChart> : <NoDataComponent />}</>
            )
          case 'InventoryPie':
            return (
              <>
              {isLoader ? 
                <div style={{ textAlign: 'center', marginTop: '13%', position:'absolute', marginLeft:'40%' }}>
                <BeatLoader />
            </div> : inventoryCount > 0 ?
              <Pie
                height='200%'
                data={inventoryBarChartdata}
                options={PieChartoptions}
                >
              </Pie> : <NoDataComponent />}</>
            )
          case 'InventoryDoughnut':
            return (
              <>
              {isLoader ? 
                <div style={{ textAlign: 'center', marginTop: '13%', position:'absolute', marginLeft:'40%' }}>
                <BeatLoader />
            </div> : inventoryCount > 0 ?
              <Doughnut
                height='200%'
                data={inventoryBarChartdata}
                options={PieChartoptions}>
              </Doughnut> : <NoDataComponent />}</>
            )
          default:
            return (
              <>
              {isLoader ? 
               <div style={{ textAlign: 'center', marginTop: '13%', position:'absolute', marginLeft:'40%' }}>
               <BeatLoader />
           </div> : inventoryCount > 0 ?
              <InventoryBarChart
              data={inventoryBarChartdata}
              options={inventoryBarChartoptions}
              >
            </InventoryBarChart> :<NoDataComponent />
              }
              </>
            )
        }
      }

    

  if(title === "Production" && allProductionCharts){
      return productionCharts(allProductionCharts,count)
  }else if(title === "Dispatch" && allDispatchCharts){
      return dispatchCharts(allDispatchCharts,count)
  }
  else if(title === "Inward" && allgetInwardCharts){
      return inwardCharts(allgetInwardCharts,count)
  }else if(title === 'Inventory' && allgetInventoryCharts){
      return inventoryCharts(allgetInventoryCharts,count)
  }else{
      switch (title) {
          case 'Production':
              return (
                  productionCharts(chartTypes,count)
              )
          case 'Dispatch':
              return (
                  dispatchCharts(chartTypes,count)
              )
          case 'Inward':
              return (
                  inwardCharts(chartTypes,count)
              )
          case 'Inventory':
              return (
                  inventoryCharts(chartTypes,count)
              )
          default:
              return null;
      }
  }
  

  }

  export default GetSimpleBarGraph